var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section main-section" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("title-comp", { attrs: { name: _vm.$t("title.password") } }),
        _c("div", { staticClass: "form-container form-login" }, [
          !_vm.restorePassword || !_vm.isTokenUser
            ? _c("div", { staticClass: "field" }, [
                _c("p", { staticClass: "control has-icons-left" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                    ],
                    staticClass: "input",
                    attrs: {
                      type: "password",
                      placeholder: _vm.$t("placeholder.password_current"),
                    },
                    domProps: { value: _vm.password },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.password = $event.target.value
                      },
                    },
                  }),
                  _c(
                    "span",
                    { staticClass: "icon is-small is-left" },
                    [_c("lock-icon", { attrs: { size: "1.5x" } })],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "field" }, [
            _c("p", { staticClass: "control has-icons-left" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newPassword,
                    expression: "newPassword",
                  },
                ],
                staticClass: "input",
                attrs: {
                  type: "password",
                  placeholder: _vm.$t("placeholder.password_new"),
                },
                domProps: { value: _vm.newPassword },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.newPassword = $event.target.value
                  },
                },
              }),
              _c(
                "span",
                { staticClass: "icon is-small is-left" },
                [_c("lock-icon", { attrs: { size: "1.5x" } })],
                1
              ),
            ]),
          ]),
          _c("div", { staticClass: "field" }, [
            _c("p", { staticClass: "control has-icons-left" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.passwordConfirm,
                    expression: "passwordConfirm",
                  },
                ],
                staticClass: "input",
                attrs: {
                  type: "password",
                  placeholder: _vm.$t("placeholder.password_confirm_new"),
                },
                domProps: { value: _vm.passwordConfirm },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.passwordConfirm = $event.target.value
                  },
                },
              }),
              _c(
                "span",
                { staticClass: "icon is-small is-left" },
                [_c("lock-icon", { attrs: { size: "1.5x" } })],
                1
              ),
            ]),
          ]),
          _c("div", { staticClass: "field margin-top-md" }, [
            _c("p", { staticClass: "control has-text-centered" }, [
              _c(
                "button",
                {
                  staticClass: "button is-primary",
                  class: _vm.buttonClass,
                  attrs: { type: "button" },
                  on: { click: _vm.submitPassword },
                },
                [
                  _vm._v(_vm._s(_vm.$t("button.submit"))),
                  _c(
                    "span",
                    { staticClass: "icon feather" },
                    [_c("chevron-right-icon")],
                    1
                  ),
                ]
              ),
            ]),
          ]),
          _vm.successPassword
            ? _c(
                "article",
                {
                  staticClass: "message is-success",
                  attrs: { transition: "fade" },
                },
                [
                  _c("div", { staticClass: "message-body" }, [
                    _vm._v(_vm._s(_vm.$t("alert.password_changed"))),
                  ]),
                ]
              )
            : _vm._e(),
          _vm.errorPassword
            ? _c(
                "article",
                {
                  staticClass: "message is-danger",
                  attrs: { transition: "fade" },
                },
                [
                  _c("div", { staticClass: "message-body" }, [
                    _vm._v(_vm._s(_vm.$t("alert.missing_password"))),
                  ]),
                ]
              )
            : _vm.errorPasswordComplexity
            ? _c(
                "article",
                {
                  staticClass: "message is-danger",
                  attrs: { transition: "fade" },
                },
                [
                  _c("div", { staticClass: "message-body" }, [
                    _vm._v(_vm._s(_vm.$t("alert.missing_password_complexity"))),
                  ]),
                ]
              )
            : _vm.errorNewPassword
            ? _c(
                "article",
                {
                  staticClass: "message is-danger",
                  attrs: { transition: "fade" },
                },
                [
                  _c("div", { staticClass: "message-body" }, [
                    _vm._v(_vm._s(_vm.$t("alert.missing_password_new"))),
                  ]),
                ]
              )
            : _vm.errorPasswordConfirm
            ? _c(
                "article",
                {
                  staticClass: "message is-danger",
                  attrs: { transition: "fade" },
                },
                [
                  _c("div", { staticClass: "message-body" }, [
                    _vm._v(_vm._s(_vm.$t("alert.missing_password_confirm"))),
                  ]),
                ]
              )
            : _vm.errorPasswordMismatch
            ? _c(
                "article",
                {
                  staticClass: "message is-danger",
                  attrs: { transition: "fade" },
                },
                [
                  _c("div", { staticClass: "message-body" }, [
                    _vm._v(
                      _vm._s(_vm.$t("alert.missing_new_password_mismatch"))
                    ),
                  ]),
                ]
              )
            : _vm.errorPasswordMatch
            ? _c(
                "article",
                {
                  staticClass: "message is-danger",
                  attrs: { transition: "fade" },
                },
                [
                  _c("div", { staticClass: "message-body" }, [
                    _vm._v(_vm._s(_vm.$t("alert.missing_new_old_password"))),
                  ]),
                ]
              )
            : _vm.errorAuth
            ? _c(
                "article",
                {
                  staticClass: "message is-danger",
                  attrs: { transition: "fade" },
                },
                [
                  _c("div", { staticClass: "message-body" }, [
                    _vm._v(_vm._s(_vm.$t("alert.invalid_login"))),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }